import React, { useMemo } from 'react';
import { ReloadOutlined } from '@ant-design/icons';

import { Button, Flex, Space, Table, type TableColumnsType } from 'antd';
import { useGetPartnersQuery } from 'src/redux/services/centralApi';
import DashboardTemplate from 'src/templates/DashboardTemplate';
import CreatePartner from 'src/pages/administration/PartnersPage/components/CreatePartner';
import DeletePartner from 'src/pages/administration/PartnersPage/components/DeletePartner';
import EditPartner from 'src/pages/administration/PartnersPage/components/EditPartner';
import CreateUserLink from 'src/pages/administration/PartnersPage/components/CreateUserLink';
import { Partner } from 'src/interfaces/entities/partners';

export default function PartnersPage() {
	const {
		data: partnersData,
		isLoading: isLoadingPartners,
		isFetching: isFetchingPartners,
		refetch: refetchPartners,
	} = useGetPartnersQuery({ size: 100, });

	const columns = useMemo<TableColumnsType<Partner>>(
		() => [
			{
				dataIndex: 'name',
				title: 'Nome',
				key: 'name',
			},
			{
				title: 'Ações',
				key: 'actions',
				render: (_, record) => (
					<Space>
						<DeletePartner row={record} />
						<EditPartner row={record} />
						<CreateUserLink row={record} />
					</Space>
				),
			},
		],
		[]
	);

	return (
		<DashboardTemplate pageTitle="Gerenciar Parceiros">
			<Flex style={{ padding: 5, marginBottom: 8, }} gap={8} justify="end">
				<CreatePartner />
				<Button
					type="text"
					onClick={refetchPartners}
					icon={<ReloadOutlined />}
				/>
			</Flex>
			<Table<Partner>
				columns={columns}
				dataSource={partnersData ?? []}
				rowKey="id"
				loading={isLoadingPartners || isFetchingPartners}
				size="small"
			/>
		</DashboardTemplate>
	);
}
